import React, { useEffect, useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Grid } from "@mui/material";

import ConfirmDialog from "../../../Common/Dialog/ConfirmDialog";
import FabButton from "../../../Common/Button/FabButton";
import ResourceCard from "./ResourceCard";

import rmsActions from "../../../../actions/rmsActions";
import { getResources, getRmsAppCode, isFetching } from "../../../../reducers";
import { DataTypes } from "../../../../constants";
import Fetching from "../../../Common/Fetching";

import ResourceForm from "./ResourceForm";
import BreadcrumbBuilder from "../BreadcrumbBuilder";

function ResourceList({
    isFetching,
    resources,
    onDelete,
    downloadResource,
    appCode,
}) {
    const [openDialog, setOpenDialog] = useState(null);
    const [selectedResource, setSelectedResource] = useState(null);

    const handleOpenResourceDialog = (resource = null) => {
        setSelectedResource(resource);
        setOpenDialog("resource");
        console.log("clicked");
    };

    const handleOpenDeleteDialog = (resource) => {
        setSelectedResource(resource);
        setOpenDialog("delete");
    };

    const handleCloseDialog = useCallback(() => {
        setOpenDialog(null);
        setSelectedResource(null);
    }, []);

    const handleDownload = useCallback(downloadResource, [downloadResource]);

    return (
        <Container className="content">
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <BreadcrumbBuilder />
                </Grid>

                {isFetching && (
                    <Grid item xs={12}>
                        <Fetching />
                    </Grid>
                )}

                {resources?.length > 0 &&
                    resources.map((resource) => (
                        <Grid item md={12} lg={6} xl={4} key={resource.id}>
                            <ResourceCard
                                resource={resource}
                                onEdit={() =>
                                    handleOpenResourceDialog(resource)
                                }
                                onDelete={() =>
                                    handleOpenDeleteDialog(resource)
                                }
                                downloadResource={handleDownload}
                            />
                        </Grid>
                    ))}
            </Grid>

            <FabButton onClick={() => handleOpenResourceDialog(null)} />

            {openDialog === "delete" && !!selectedResource && (
                <ConfirmDialog
                    open={true}
                    title="Delete resource"
                    content={`The following resource will be deleted: ${selectedResource.title}`}
                    confirmButtonLabel="Delete"
                    onConfirm={() => onDelete(selectedResource.id)}
                    onCancel={handleCloseDialog}
                    onClose={handleCloseDialog}
                />
            )}

            {openDialog === "resource" && (
                <ResourceForm
                    open={true}
                    onClose={handleCloseDialog}
                    resource={selectedResource}
                    appCode={appCode}
                />
            )}
        </Container>
    );
}

const ResourceListContainer = () => {
    const dispatch = useDispatch();
    const resources = useSelector((state) => getResources(state));
    const isFetchingState = useSelector((state) =>
        isFetching(state, DataTypes.RESOURCES)
    );
    const appCode = useSelector(getRmsAppCode);

    useEffect(() => {
        dispatch(rmsActions.getResources(appCode));
    }, [dispatch, appCode]);

    const handleDownload = (onSuccess, url) =>
        dispatch(rmsActions.downloadResource(appCode, url, onSuccess));

    return (
        <ResourceList
            resources={resources}
            isFetching={isFetchingState}
            downloadResource={handleDownload}
            onDelete={(id) => dispatch(rmsActions.deleteResource(id, appCode))}
            appCode={appCode}
        />
    );
};

export default ResourceListContainer;
